import { render, staticRenderFns } from "./TimerCountdown.vue?vue&type=template&id=52ed205f&scoped=true"
import script from "./TimerCountdown.vue?vue&type=script&lang=js"
export * from "./TimerCountdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ed205f",
  null
  
)

export default component.exports